/**
 * User: n.gorte
 * Date: 11.04.2019
 * Time: 10:28
 */
'use strict';

import '../css/leaflet-control-positions.scss';

/**
 * Extends leaflet control positions with 'bottomcenter', 'topcenter', 'leftcenter', 'rightcenter'
 */
L.Map.include({
    _initControlPos() {
        const corners = this._controlCorners = {};
        const l = 'leaflet-';
        const container = this._controlContainer =
            L.DomUtil.create('div', l + 'control-container', this._container);

        const createCorner = (vSide, hSide) => {
            const className = l + vSide + ' ' + l + hSide;
            return corners[ vSide + hSide ] = L.DomUtil.create('div', className, container);
        };

        createCorner('top', 'left');
        createCorner('top', 'right');
        createCorner('top', 'center');
        createCorner('bottom', 'left');
        createCorner('bottom', 'right');
        createCorner('bottom', 'center');
        createCorner('left', 'center');
        createCorner('right', 'center');
    }
});
 
    


// WEBPACK FOOTER //
// ./js/utils/leaflet-control-positions.js